declare var settings: any;

module EEX.McEc.Apps {

    import UserInfo = AppKitchen.Api.Models.UserInfo;
    import InactivityLogout = AppKitchen.InactivityLogout;

    export class MainApp extends AppKitchen.AppBase<AppKitchen.AppBaseOptions> {

        start() {

            var certificateCreateDialog = new AppKitchen.FrameManager.RoutedApp(Apps.CertificateCreateDialogApp, "CertificateCreateDialog");
            var serverCertificateCreateDialog = new AppKitchen.FrameManager.RoutedApp(Apps.ServerCertificateCreateDialogApp, "ServerCertificateCreateDialog");
            var certificateDownloadDialog = new AppKitchen.FrameManager.RoutedApp(Apps.CertificateDownloadDialogApp, "CertificateDownloadDialog");

            var routedApps = [
                certificateCreateDialog,
                serverCertificateCreateDialog,
                certificateDownloadDialog
            ];

            /*AppKitchen.InactivityLogout.*/
            InactivityLogout.setupTimersAndStart();

            this.loadUserInfo((userInfo: UserInfo) => {
                var menu = new AppKitchen.FrameManager.MenuItem(Strings.Menu_PageTitle, null, []);
                let certificateRoute = "";
                if (userInfo.IsSysAdmin || userInfo.IsServerCertApplier) {
                    certificateRoute = "Certificates";
                    routedApps.push(new AppKitchen.FrameManager.RoutedApp(Apps.DashboardApp, ""));
                    routedApps.push(new AppKitchen.FrameManager.RoutedApp<ServerCertificatesAppOptions>(Apps.ServerCertificatesApp,
                        "ServerCertificates",
                        {
                            serverCertificateCreateDialog: serverCertificateCreateDialog,
                            certificateDownloadDialog: certificateDownloadDialog,
                            authorityId: settings.AuthorityId
                        }));

                    menu.children.push(
                        new AppKitchen.FrameManager.MenuItem(Strings.Menu_Certificates,
                            {
                                route: "Certificates",
                                highlightOnNavigate: true
                            })
                    );

                    menu.children.push(
                        new AppKitchen.FrameManager.MenuItem(Strings.Menu_ServerCertificates,
                            {
                                route: "ServerCertificates",
                                highlightOnNavigate: true
                            })
                    );
                }

                routedApps.push(new AppKitchen.FrameManager.RoutedApp<CertificatesAppOptions>(Apps.CertificatesApp,
                    certificateRoute,
                    {
                        certificateCreateDialog: certificateCreateDialog,
                        certificateDownloadDialog: certificateDownloadDialog,
                        authorityId: settings.AuthorityId
                    }));

                // ReSharper disable once WrongExpressionStatement
                new AppKitchen.FrameManager.MainApp(this.el,
                    {
                        apps: routedApps,
                        mainMenu: menu,
                        helpMenu: {
                            customItems: [
                            ]
                        },
                        userMenu: {
                            extendedUserInfo: true
                        },
                        footerTemplate: AppKitchen.UIHelper.renderTemplate(Templates.Footer, {
                            copyright: AppKitchen.GlobalSettings.applicationCopyright,
                            cookieSettings: `${AppKitchen.GlobalSettings.securityTokenServiceOAuthUrl}CookieSettings`,
                            privacy: `${AppKitchen.GlobalSettings.securityTokenServiceOAuthUrl}Privacy`,
                            imprint: `${AppKitchen.GlobalSettings.securityTokenServiceOAuthUrl}Imprint`
                        })
                    });
            });
        }

        private loadUserInfo(success: (userInfo: UserInfo) => void) {
            AppKitchen.Data.Api.getUserInfo((userInfo: UserInfo) => {
                    success(userInfo);
                },
                (requestData, xhr) => {
                    AppKitchen.UIHelper.Notifications.notify(xhr.responseText, "warning");
                });
        }
    }
}